import { useState } from "react";
import { useDispatch } from "react-redux";
import { useApiClient } from "../../useApiClient";
import { useAuthUser } from "../../useLogin";

const useMoveSPToCompleted = (serviceRequestId, storefrontId) => {
  const dispatch = useDispatch();
  const { apiClient } = useApiClient();
  const userInfo = useAuthUser();

  const [ratingValue, setRatingValue] = useState(0);
  const [reviewComment, setReviewComment] = useState("");

  const data = {
    reviewComments: reviewComment,
    starRating: ratingValue,
  };

  const moveRequestToCompleted = (onResult) => {
    dispatch({ type: "SET_LOADING", value: true });
    apiClient
      .put(`/home-buyer/sp/service-request/completed/${serviceRequestId}`, data)
      .then((res) => {
        onResult && onResult(res);
      })
      .catch((error) => {
        console.error(error);
      })
      .then(function () {
        dispatch({ type: "SET_LOADING", value: false });
      });
  };

  return {
    moveRequestToCompleted,
    ratingValue,
    setRatingValue,
    reviewComment,
    setReviewComment,
  };
};

export default useMoveSPToCompleted;
